import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { InvitationInterface } from '@app/interface/invitation';

@Injectable({
  providedIn: 'root',
})
export class InvitationApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  // public getAllInvitations<T = InvitationInterface>(
  //   params: httpQueryParams = {}
  // ): Subject<RecursiveInterface<T>> {
  //   const organization_id = 1; // FIXME: You might want to make this dynamic
  //   const path = `api/${organization_id}/invitation/`;
  //   return this.getRecursivePage<T>(path, params);
  // }

  // public createInvitation(
  //   invitationData: Partial<InvitationInterface>
  // ): Observable<InvitationInterface> {
  //   let organization_id = 1; // FIXME: You might want to make this dynamic

  //   if (!invitationData.organization_id) {
  //     invitationData.organization_id = 1; // Default to company with ID 1
  //   } else {
  //     organization_id = invitationData.organization_id;
  //   }
  //   const path = `api/${organization_id}/invitation/`;

  //   return this.post<InvitationInterface>(path, {}, invitationData);
  // }

  // Send invitation to email
  // public sendInvitation(
  //   organizationId: number,
  //   email: string
  //   // invitationData: Partial<InvitationInterface>
  // ): Observable<any> {
  //   let organization_id = 1; // FIXME: You might want to make this dynamic

  //   // if (!invitationData.organization_id) {
  //   //   invitationData.organization_id = 1; // Default to company with ID 1
  //   // } else {
  //   //   organization_id = invitationData.organization_id;
  //   // }

  //   const path = `api/organizations/${organizationId}/invitations/invite/`;
  //   return this.post<any>(path, { email }, { organization_id });
  // }

  // // Accept invitation
  // public acceptInvitation(uuid: string): Observable<any> {
  //   const path = `api/invitations/accept/${uuid}/`;
  //   return this.post<any>(path, {});
  // }

  // // Decline invitation
  // public declineInvitation(uuid: string): Observable<any> {
  //   const path = `api/invitations/decline/${uuid}/`;
  //   return this.post<any>(path, {});
  // }

  // Get user's pending invitations
  // public getMyInvitations(): Observable<InvitationInterface[]> {
  //   const path = `api/invitations/invite/`;
  //   return this.get<InvitationInterface[]>(path);
  // }

  // Get organization invitations (for admins)
  public getOrganizationInvitations(
    organizationId: number,
    params: httpQueryParams = {}
  ): Observable<InvitationInterface[]> {
    // Change return type
    const path = `api/organizations/${organizationId}/invitations/`;

    // If your base service has a simple get method, use it instead of getRecursivePage
    return this.get<InvitationInterface[]>(path, params);
  }

  public sendInvitation(
    organizationId: number,
    email: string
  ): Observable<any> {
    const path = `api/organizations/${organizationId}/invitations/`; // Note: removed /invite/ from the path

    // Send the data in the correct format expected by your serializer
    const invitationData = {
      email: email,
      organization_id: organizationId,
    };

    return this.post<any>(path, {}, invitationData);
  }
}
